import { render, staticRenderFns } from "./MissingImage.vue?vue&type=template&id=106cb59a&"
import script from "./MissingImage.vue?vue&type=script&lang=js&"
export * from "./MissingImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/Kristian/Local Sites/boligvelger/app/public/wp-content/plugins/ensign-boligprosjekter-blocks/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('106cb59a')) {
      api.createRecord('106cb59a', component.options)
    } else {
      api.reload('106cb59a', component.options)
    }
    module.hot.accept("./MissingImage.vue?vue&type=template&id=106cb59a&", function () {
      api.rerender('106cb59a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/MissingImage.vue"
export default component.exports